import { render, staticRenderFns } from "./TruckInComponents.vue?vue&type=template&id=5d527656&scoped=true&"
import script from "./TruckInComponents.vue?vue&type=script&lang=js&"
export * from "./TruckInComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d527656",
  null
  
)

export default component.exports